import React from 'react';
import { Button } from './Button';
const TESTIMONIALS = [{
  quote: 'Antes buscaba fichas en grupos de WhatsApp. Ahora entro a cada sesión sabiendo exactamente qué voy a hacer. El cambio fue inmediato.',
  name: 'Valeria G.',
  role: 'Fonoaudióloga, Buenos Aires',
  img: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=200&auto=format&fit=crop'
}, {
  quote: 'Lo compré un jueves. El viernes ya lo estaba usando con una paciente nueva. No tuve que adaptar absolutamente nada.',
  name: 'Daniela S.',
  role: 'Neurolingüista, Mendoza',
  img: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=200&auto=format&fit=crop'
}, {
  quote: 'El Módulo de Familia y Escuela me cambió cómo trabajo con el entorno. Siempre supe que importaba pero nunca tuve el material para trabajarlo bien.',
  name: 'Luciana M.',
  role: 'Psicopedagoga, Córdoba',
  img: 'https://images.unsplash.com/photo-1554727242-741c14fa561c?q=80&w=200&auto=format&fit=crop'
}, {
  quote: 'Las 100 frases para padres fueron una sorpresa enorme. Los padres no saben qué decir y yo tampoco sabía cómo enseñárselos. Ahora les doy el material y el paciente llega diferente a la próxima sesión.',
  name: 'Carla F.',
  role: 'Fonoaudióloga, La Plata',
  img: 'https://images.unsplash.com/photo-1598550874175-4d0ef436c909?q=80&w=200&auto=format&fit=crop'
}];
export function Testimonials() {
  return <section className="flex flex-col gap-8 py-12 border-t border-stone-200" data-id="element-146">
      <h3 className="font-serif text-3xl font-bold text-[#0F4C3A] text-center" data-id="element-147">
        Lo que dicen las que ya lo usan
      </h3>

      <div className="flex flex-col gap-6" data-id="element-148">
        {TESTIMONIALS.map((test, idx) => <div key={idx} className="flex flex-col bg-white p-8 rounded-2xl shadow-md border border-stone-100 gap-6 items-center text-center" data-id="element-149">
            <p className="font-serif text-lg italic text-stone-700" data-id="element-150">
              "{test.quote}"
            </p>
            <div className="flex flex-col items-center gap-3" data-id="element-151">
              <img src={test.img} alt={test.name} className="w-16 h-16 rounded-full object-cover shadow-sm" data-id="element-152" />
              <div className="flex flex-col gap-1" data-id="element-153">
                <p className="font-bold text-stone-900" data-id="element-154">{test.name}</p>
                <p className="text-sm text-stone-500" data-id="element-155">{test.role}</p>
              </div>
            </div>
          </div>)}
      </div>

      <div className="mt-6" data-id="element-156">
        <Button href="#compra" data-id="element-157">EMPEZAR AHORA CON DESCARGA INMEDIATA →</Button>
      </div>
    </section>;
}